import type { SelectOption } from '.';

export const formatLabel =
  (options: SelectOption[]) =>
  (newValue: string): string =>
    options.find(({ value: optionValue }) => optionValue === newValue)?.label || newValue;
